// AEM = Annual Emissions Multiplier
// AEF = Anode Effect Frequency
// AED = Anode Effect Duration

// Equation 23
export function calcualteAEM(frequency: number, averageDuration: number) {
  return frequency * averageDuration
}

// Equation 21
export function calculateCf4Emissions(
  AEM: number,
  cf4EmissionFactor: number,
  aluminiumQuantityTonnes: number
) {
  return AEM * (cf4EmissionFactor / 1000) * aluminiumQuantityTonnes
}

// Equation 22
export function calculateC2f6Emissions(cf4Emissions: number, c2f6Coefficient: number) {
  return cf4Emissions * c2f6Coefficient
}

// Equation 20
export default function calculatePFCEmissionsUsingSlopeMethod({
  frequency,
  averageDuration,
  cf4EmissionFactor: cf4Coefficient,
  c2f6EmissionFactor: c2f6Coefficient,
  aluminiumQuantityTonnes,
  gwpcf4: cf4GWP,
  gwpc2f6: c2f6GWP,
  collectionEfficiency
}: {
  frequency: number
  averageDuration: number
  cf4EmissionFactor: number
  c2f6EmissionFactor: number
  aluminiumQuantityTonnes: number
  gwpcf4: number
  gwpc2f6: number
  collectionEfficiency: number
}): number {
  const AEM = calcualteAEM(frequency, averageDuration)

  const cf4Emissions = calculateCf4Emissions(AEM, cf4Coefficient, aluminiumQuantityTonnes)

  const c2f6Emissions = calculateC2f6Emissions(cf4Emissions, c2f6Coefficient)

  const cf4Co2 = cf4Emissions * cf4GWP
  const c2f6Co2 = c2f6Emissions * c2f6GWP
  const emission = cf4Co2 + c2f6Co2

  if (collectionEfficiency === 100) {
    return emission
  }

  return emission + emission * (1 - collectionEfficiency / 100)
}
